import type { ComputedRef, Ref } from 'vue'
import { computed, ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'

import type { LoginResponseSuccessFragment, MeFragment } from '@/graphql/api'

export interface Auth {
    user: Readonly<Ref<MeFragment | undefined | null>>
    loginMessage: Readonly<Ref<string | null>>
    isLogged: ComputedRef<boolean>
    setLoginMessage: (token: string | null) => void
    setUser: (u: MeFragment | null | undefined) => void
    setAuth: (auth: LoginResponseSuccessFragment | null) => void
}

export function useAuth(): Auth {
    const { loginMessage } = storeToRefs(useAuthStore())
    const { user } = storeToRefs(useAuthTemporaryStore())

    const isLogged = computed(() => Boolean(user.value))

    const setLoginMessage = (message: string | null) => {
        loginMessage.value = message
    }

    const setUser = (u: MeFragment | null | undefined) => {
        if (!u) {
            user.value = null

            return
        }

        user.value = u

        loginMessage.value = null
    }

    const setAuth = (auth: LoginResponseSuccessFragment | null) => {
        if (!auth) {
            setUser(null)

            return
        }

        setUser(auth.user)
    }

    return {
        user,
        loginMessage,
        isLogged,
        setLoginMessage,
        setUser,
        setAuth,
    }
}

const useAuthStore = defineStore(
    'auth',
    () => {
        const loginMessage: Ref<string | null> = ref(null)

        return {
            loginMessage,
        }
    },
    {
        persist: true,
    }
)

const useAuthTemporaryStore = defineStore('authTemp', () => {
    const user = ref<MeFragment | undefined | null>(undefined)

    return {
        user,
    }
})
